import MarginsOverlay from '@/components/app/document/overlays/margins-overlay'
import { computeSnappedPageTrimWidth } from '../helpers/page-trim-width'

type DoubleSpreadMarginGuidesAboveShapesProps = {
  bleedMargin: number
  trimWidth: number
  trimHeight: number
  marginInside: number
  marginOutside: number
  marginTop: number
  marginBottom: number
  /** Z-index for each segment (above shapes/text; avoid a full-bleed wrapper). */
  lineZIndex: number
  scale: number
  /**
   * Shared, snapped spine seam (ruler "0" / spine bar / page-trim split in
   * `double-spread-document.tsx`) — keeps both pages' margin boxes split at the same seam those
   * draw at, instead of an independently-floored approximation that can drift a fraction of a
   * point off it.
   */
  spineSnapCanvasX?: number
}

/**
 * Pink margin guides for both halves of a spread, including the spine-side verticals. Sits above
 * `ShapeManager` / `TextManager` with per-segment `lineZIndex` (no full-bleed stacking context).
 */
export function DoubleSpreadMarginGuidesAboveShapes({
  bleedMargin,
  trimWidth,
  trimHeight,
  marginInside,
  marginOutside,
  marginTop,
  marginBottom,
  lineZIndex,
  scale,
  spineSnapCanvasX,
}: DoubleSpreadMarginGuidesAboveShapesProps) {
  const leftTrimLeft = bleedMargin
  const pageTrimWidth = computeSnappedPageTrimWidth(leftTrimLeft, trimWidth, spineSnapCanvasX)

  if (pageTrimWidth <= 0) {
    return null
  }

  const rightTrimLeft = leftTrimLeft + pageTrimWidth

  return (
    <>
      <MarginsOverlay
        trimLeft={leftTrimLeft}
        trimTop={bleedMargin}
        trimWidth={pageTrimWidth}
        trimHeight={trimHeight}
        inside={marginInside}
        outside={marginOutside}
        top={marginTop}
        bottom={marginBottom}
        insideOnLeft={false}
        lineZIndex={lineZIndex}
        scale={scale}
      />
      <MarginsOverlay
        trimLeft={rightTrimLeft}
        trimTop={bleedMargin}
        trimWidth={pageTrimWidth}
        trimHeight={trimHeight}
        inside={marginInside}
        outside={marginOutside}
        top={marginTop}
        bottom={marginBottom}
        insideOnLeft
        lineZIndex={lineZIndex}
        scale={scale}
      />
    </>
  )
}
